import React from 'react';

import Box from '@mui/material/Box';

const Flex = (props) => <Box display="flex" {...props} />;

export const FlexGrow = (props) => <Box flexGrow={1} {...props} />;

export const FlexColumn = (props) => <Box display="flex" flexDirection="column" {...props} />;

export const FlexCenter = (props) => <Box display="flex" justifyContent="center" {...props} />;

export default Flex;
